import { all, takeLatest, take, fork, call } from 'redux-saga/effects'
import * as Actions from 'domain/recruiter/importedCandidate/actions'
import * as Sagas from 'domain/recruiter/importedCandidate/sagas'
import { checkUserEmail } from 'domain/env'
import { ensureCheckUserEmail } from 'domain/env/sagas'

export function* profilePage() {
  yield all([
    fork(getProfile),
    fork(putProfile),
    fork(addAvatarProfile),
    fork(deleteResumeProfile),
    fork(checkCandidateEmail),
    fork(postResume)
  ])
}

function* checkCandidateEmail() {
  yield takeLatest(checkUserEmail.TRIGGER, ensureCheckUserEmail)
}

function* getProfile() {
  yield call(Sagas.ensureGetImportedCandidate)
  yield takeLatest(Actions.importedCandidateProfile.type, Sagas.ensureGetImportedCandidate)
  yield take(Actions.importedCandidateProfile.success)
}

function* putProfile() {
  yield takeLatest(Actions.candidatesEdit.TRIGGER, Sagas.ensureEditProfileIC)
  yield take(Actions.candidatesEdit.SUCCESS)
}

function* addAvatarProfile() {
  yield takeLatest(Actions.addCandidatesAvatar.type, Sagas.ensureAddAvatarIC)
  yield take(Actions.addCandidatesAvatar.success)
}

function* deleteResumeProfile() {
  yield takeLatest(Actions.candidatesDeleteResume.type, Sagas.ensureDeleteResumeIC)
  yield take(Actions.candidatesDeleteResume.success)
}

function* postResume() {
  yield takeLatest(Actions.resumeAdd.TRIGGER, Sagas.ensureParseResume)
  yield take(Actions.resumeAdd.SUCCESS)
}
